'use strict';

var dialog = require('../dialog'),
	formPrepare = require('./checkout/formPrepare');

var quickorder = {
	addAllToCart: function (e) {
		e.preventDefault();
		var url = $('#quick-order-items-form').attr('action'),
			options = {
				url: url,
				data: e.currentTarget.name + '=1'
			};
		$.ajax(options).done(function (data) {
			if (data.success === false && data.error === 'CART_MAX') {
				dialog.open({
					url: Urls.maxLineItemQuota,
					options: {
						buttons: [
							{
								text: Resources.GOT_IT,
								click: function () {
									$(this).dialog('close');
								}
							}
						],
						title: Resources.MAX_QUOTA_TITLE
					}
				});
			} else if (data.success === false && data.error === 'TC_DEBT') {
				dialog.open({
					url: Urls.tcSettleBalanceError,
					options: {
						buttons: [
							{
								text: Resources.CANCEL,
								'class':'button-gray',
								click: function () {
									$(this).dialog('close');
								}
							},
							{
								text: Resources.SETTLE_BALANCE,
								click: function () {
									window.location = Urls.shippingStart;
								}
							}
						],
						title: Resources.SORRY
					}
				});
			} else {
				$('body').append(data);
				$('#auto-accept').submit();
			}
		});
	},
	init: function () {
		$('#quickorder-add-all').on('click', function (e) {
			quickorder.addAllToCart(e);
		});
		formPrepare.init({
			continueSelector: '[name$="_quickorder_search"]',
			formSelector: '#quick-order-items-form'
		});
	}
};

module.exports = quickorder;
